import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ITEM_SX = { fontSize: '0.875rem' };

/**
 * Menu único da refeição (ordem, duplicar, observação, remover), no lugar
 * de uma fileira de ícones no cabeçalho.
 */
const MealMenu = ({
  canMoveUp,
  canMoveDown,
  canDuplicate,
  canAddNote,
  onMoveUp,
  onMoveDown,
  onDuplicate,
  onAddNote,
  onRemove,
}) => {
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  const run = (action) => () => {
    close();
    action();
  };

  return (
    <>
      <Tooltip title="Opções da refeição">
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)} aria-label="Opções da refeição">
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem disabled={!canMoveUp} onClick={run(onMoveUp)} sx={ITEM_SX}>Mover para cima</MenuItem>
        <MenuItem disabled={!canMoveDown} onClick={run(onMoveDown)} sx={ITEM_SX}>Mover para baixo</MenuItem>
        <MenuItem disabled={!canDuplicate} onClick={run(onDuplicate)} sx={ITEM_SX}>Duplicar</MenuItem>
        {canAddNote && <MenuItem onClick={run(onAddNote)} sx={ITEM_SX}>Adicionar observação</MenuItem>}
        <MenuItem onClick={run(onRemove)} sx={ITEM_SX}>Remover refeição</MenuItem>
      </Menu>
    </>
  );
};

export default MealMenu;
